
export default {
  name: 'CustomTable',
  props: {
    table: {
      type: Object,
      required: true
    },
    firstColumnWidth: {
      type: String,
      required: false,
      default: '13.6rem'
    },
    columnWidth: {
      type: String,
      required: false,
      default: '12.4rem'
    }
  },
  computed: {
    gridColumnsCss () {
      return {
        '--columns': this.table.thead.length - 1,
        '--first-column-width': this.firstColumnWidth,
        '--column-width': this.columnWidth
      }
    }
  }
}
